module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": "none"
	},
	"fr": 30,
	"ip": 0,
	"op": 101,
	"w": 292,
	"h": 152,
	"nm": "Speedometer_PriceVSpeed_NoLoop_03_Lottie",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Needle",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 40,
							"s": [
								-90
							]
						},
						{
							"t": 80,
							"s": [
								-65
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						146,
						137.875,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						61.875,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.031,
											62.25
										],
										[
											-0.031,
											-62.25
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.4
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 20,
								"s": [
									0
								]
							},
							{
								"t": 52,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Small Ticks",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 20,
							"s": [
								0
							]
						},
						{
							"t": 64,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						146,
						146,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						70,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-130,
											69.875
										],
										[
											-140.375,
											69.875
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.854902029037,
									0.862745165825,
									0.886274576187,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 5,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									69.745
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									69.745
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "rp",
					"c": {
						"a": 0,
						"k": 30,
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 2
					},
					"m": 1,
					"ix": 2,
					"tr": {
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [
								0,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								70
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100
							],
							"ix": 3
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.4
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 20,
									"s": [
										0
									]
								},
								{
									"t": 50,
									"s": [
										6
									]
								}
							],
							"ix": 4
						},
						"so": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.4
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 20,
									"s": [
										0
									]
								},
								{
									"t": 58,
									"s": [
										100
									]
								}
							],
							"ix": 5
						},
						"eo": {
							"a": 0,
							"k": 100,
							"ix": 6
						},
						"nm": "Transform"
					},
					"nm": "Repeater 1",
					"mn": "ADBE Vector Filter - Repeater",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Big Ticks ",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 20,
							"s": [
								0
							]
						},
						{
							"t": 50,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						146,
						146,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						70,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-120.25,
											69.875
										],
										[
											-140.375,
											69.875
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.854902029037,
									0.862745165825,
									0.886274576187,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 5,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									69.745
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									69.745
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "rp",
					"c": {
						"a": 0,
						"k": 7,
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 2
					},
					"m": 1,
					"ix": 2,
					"tr": {
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [
								0,
								0
							],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								70
							],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100
							],
							"ix": 3
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.4
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 20,
									"s": [
										0
									]
								},
								{
									"t": 50,
									"s": [
										30
									]
								}
							],
							"ix": 4
						},
						"so": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.4
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 20,
									"s": [
										0
									]
								},
								{
									"t": 50,
									"s": [
										100
									]
								}
							],
							"ix": 5
						},
						"eo": {
							"a": 0,
							"k": 100,
							"ix": 6
						},
						"nm": "Transform"
					},
					"nm": "Repeater 1",
					"mn": "ADBE Vector Filter - Repeater",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Circle/Speedometer_Base_01 Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 0,
							"s": [
								0
							]
						},
						{
							"t": 20,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						146.125,
						76,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						142,
						72,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-5.456
										],
										[
											5.455,
											0
										],
										[
											0,
											5.456
										],
										[
											-5.456,
											0
										]
									],
									"o": [
										[
											0,
											5.456
										],
										[
											-5.456,
											0
										],
										[
											0,
											-5.456
										],
										[
											5.455,
											0
										]
									],
									"v": [
										[
											9.878,
											0
										],
										[
											0,
											9.878
										],
										[
											-9.879,
											0
										],
										[
											0,
											-9.878
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									141.676,
									133.824
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Gradient Stroke",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 0,
							"s": [
								0
							]
						},
						{
							"t": 40,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 0,
							"s": [
								-180
							]
						},
						{
							"t": 40,
							"s": [
								0
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						145.5,
						146,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							241,
							241
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 50,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": -90,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "gs",
					"o": {
						"a": 0,
						"k": 100,
						"ix": 9
					},
					"w": {
						"a": 0,
						"k": 36,
						"ix": 10
					},
					"g": {
						"p": 3,
						"k": {
							"a": 0,
							"k": [
								0,
								0.404,
								0.522,
								0.718,
								0.5,
								0.404,
								0.522,
								0.718,
								1,
								0.404,
								0.522,
								0.718,
								0,
								0.8,
								0.5,
								0.4,
								1,
								0
							],
							"ix": 8
						}
					},
					"s": {
						"a": 0,
						"k": [
							145,
							50
						],
						"ix": 4
					},
					"e": {
						"a": 0,
						"k": [
							-145,
							50
						],
						"ix": 5
					},
					"t": 1,
					"lc": 1,
					"lj": 1,
					"ml": 4,
					"ml2": {
						"a": 0,
						"k": 4,
						"ix": 13
					},
					"bm": 0,
					"nm": "Gradient Stroke 1",
					"mn": "ADBE Vector Graphic - G-Stroke",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/speedometers/Speedometer_PriceVSpeed_NoLoop_03_Lottie.json
// module id = 655
// module chunks = 0